export default class QuestionValue {
    constructor(value) {
        this._value = value;
    }

    toString(addCommas = true) {
        addCommas = true;//client wants always commas, but just in case this changes can uncomment here
        return addCommas? numberWithCommas(this._value) : this._value.toString();

        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    get value() {
        return this._value;
    }
}